import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Text from 'components/common/Text/Text'
import Button from 'components/common/Button/Button'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import CompareTrayItem from '../CompareTrayItem'

const CompareTrayMobile = ({
  compareItems,
  disableCompare,
  expanded,
  items,
  toggleHandlers: {
    onClick
  },
  traySummary
}) =>
  <Wrapper expanded={ expanded } data-at-compare-tray-mobile>
    {
      expanded ?
        <Products>
          {
            items.map((data = {}, index) =>
              <CompareTrayItem key={ `${data.skuId}-${index}` } { ...data } />
            )
          }
        </Products> :
        <Summary>{ traySummary }</Summary>
    }
    <Controls>
      <Toggle
        data-at-toggle-compare-button
        asset="arrow-up-gray"
        alternative="arrow-down-gray"
        condition={ expanded }
        onClick={ onClick } />
      <Apply
        data-at-compare-button
        secondary
        full
        disabled={ disableCompare }
        hidden={ !expanded }
        onClick={ compareItems }>
        Compare
      </Apply>
    </Controls>
  </Wrapper>

export default CompareTrayMobile

CompareTrayMobile.propTypes = {
  compareItems: PropTypes.func,
  disableCompare: PropTypes.bool,
  expanded: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape()),
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  traySummary: PropTypes.string
}

const Wrapper = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  height: ${props => props.expanded ? 89 : 39}px;
  padding: 4px 2px 3px;
  background-color: ${Theme.colors.off_white};
  z-index: 1;
`

const Toggle = styled(Icon)`
  width: 30px;
`

const Products = styled.div`
  display: inline-flex;
  flex-grow: 1;
  height: 100%;
`

const Controls = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: 29%;
  padding: 0 4.5%;
`

const Apply = styled(Button)`
  padding: 11px 0 9px;
  margin-bottom: 8px;
`

const Summary = styled(Text)`
  padding-left: 31px;
  text-transform: uppercase;
  ${Mixin.font.GothamBook(16, 400)}
`
